module.exports = function() {
  return new Worker(__webpack_public_path__ + "69c0732d4b6e2533bbb1.worker.js");
};